enum FileExtension {
  Excel = 'xlsx',
  Pdf = 'pdf',
}

enum FileMimeType {
  Excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Pdf = 'application/pdf',
}

export { FileExtension, FileMimeType };
